import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import classNames from "classnames";
import scrollIntoView from "dom-scroll-into-view";
import { Component } from "react";
import { Checkbox, Spin } from "./index.js";
import { parents } from "../util/index.js";
export const toId = (test)=>isNaN(parseInt(test)) ? test : parseInt(test);
/**
 * Tree node with child nodes and rename / create mode.
 *
 * @returns
 */ export class TreeNode extends Component {
    static #_ = this.defaultProps = {
        id: undefined,
        hash: "",
        className: undefined,
        icon: undefined,
        iconActive: undefined,
        childNodes: [],
        title: "",
        count: 0,
        attr: {},
        renameSaveText: "Save",
        renameAddText: "Add",
        $busy: false,
        $droppable: true,
        $visible: true,
        $rename: undefined,
        $create: undefined,
        $checkable: false,
        searchSelected: false,
        expandedState: true,
        displayChildren: true,
        checked: false,
        indeterminate: false,
        selected: false,
        onRenameClose: undefined,
        onAddClose: undefined,
        onCheck: undefined,
        onSelect: undefined,
        onNodePressF2: undefined,
        onExpand: undefined,
        onUlRef: undefined
    };
    static #_2 = this.stateKeys = "expanded,inputValue,initialInputValue".split(",");
    constructor(props){
        super(props);
        this.handleInputKeyDown = (e)=>{
            if (e.key === "Enter") {
                this.handleButtonSave(true);
            } else if (e.key === "Escape") {
                this.handleButtonSave(false);
            }
        };
        this.handleNodeKeyDown = (e)=>{
            if (e.key === "F2" && !this.props.$rename) {
                this.props.onNodePressF2 && this.props.onNodePressF2(this.props);
            }
        };
        this.handleButtonSave = (save)=>{
            const _save = typeof save === "boolean" ? save : true;
            const { inputValue } = this.state;
            if (_save === true && !inputValue) {
                return;
            }
            this.props.onRenameClose && this.props.onRenameClose(_save, inputValue, this.props);
        };
        this.handleChange = (e)=>{
            this.setState({
                inputValue: e.target.value
            });
        };
        this.handleSelect = (e)=>{
            if (!parents(e.target, ".aiot-disable-links").length && !parents(e.target, ".ant-checkbox-wrapper").length) {
                this.props.onSelect && this.props.onSelect(this.props.id);
            }
        };
        this.handleToggle = (e)=>{
            const newExpanded = !this.state.expanded;
            const { onExpand } = this.props;
            this.setState({
                expanded: newExpanded
            });
            onExpand && onExpand(newExpanded, this.props);
            e.preventDefault();
        };
        this.handleRef = (node)=>{
            this.refNode = node;
            this.props.$_create && this.scrollTo();
        };
        this.handleCheck = ()=>{
            this.props.onCheck && this.props.onCheck(this.props.id);
        };
        !TreeNode.propKeys && (TreeNode.propKeys = Object.keys(TreeNode.defaultProps));
        // Get expanded state
        const { id, expandedState } = props;
        const expanded = id && typeof expandedState[id] === "boolean" ? expandedState[id] : true;
        this.state = {
            expanded,
            inputValue: "",
            initialInputValue: false
        };
    }
    shouldComponentUpdate(nextProps, nextState) {
        const changedProps = TreeNode.propKeys.filter((k)=>this.props[k] !== nextProps[k]);
        const changedState = TreeNode.stateKeys.filter((k)=>this.state[k] !== nextState[k]);
        if (!changedProps.length && !changedState.length) {
            // Nothing changed
            return false;
        }
        return true;
    }
    componentDidUpdate() {
        const { id, title, $rename, $_create, searchSelected, expandedState } = this.props;
        // Scroll to search result
        searchSelected && this.scrollTo();
        // Update the expanded state depending on the expanded property.
        const expanded = id && typeof expandedState[id] === "boolean" ? expandedState[id] : true;
        if (expanded !== this.state.expanded) {
            this.setState({
                expanded
            });
        }
        // Avoid controlled / uncontrolled switch when creating a new node
        if ($_create) {
            return;
        }
        if (this.state.inputValue !== title && $rename && !this.state.initialInputValue) {
            this.setState({
                inputValue: title,
                initialInputValue: true
            });
        } else if (!$rename && this.state.initialInputValue) {
            this.setState({
                inputValue: "",
                initialInputValue: false
            });
        }
    }
    scrollTo() {
        const container = this.refNode;
        container && scrollIntoView(container, window, {
            onlyScrollIfNeeded: true,
            alignWithTop: false
        });
    }
    render() {
        const { icon, childNodes = [], id, title, count, selected, $rename, $busy, $droppable = true, $create, $visible = true, $_create, searchSelected, attr, checked, indeterminate } = this.props;
        const { expandedState, displayChildren, renderItem, renderIcon, $checkable, onRenameClose, onCheck, onAddClose, onSelect, onNodePressF2, onExpand, onUlRef, renameSaveText, renameAddText } = this.props;
        const nodeAttr = {
            expandedState,
            displayChildren,
            renderItem,
            renderIcon,
            $checkable,
            onRenameClose,
            onCheck,
            onAddClose,
            onSelect,
            onNodePressF2,
            onExpand,
            onUlRef,
            renameSaveText,
            renameAddText
        };
        const visibleChildNodes = childNodes && childNodes.filter((param)=>{
            let { $visible = true } = param;
            return !!$visible;
        });
        const togglable = !!(displayChildren && visibleChildNodes && visibleChildNodes.length);
        const isExpanded = this.state.expanded || !!$create;
        const isActive = $create ? false : $_create ? true : selected;
        const className = classNames("aiot-node", this.props.className, {
            "aiot-active": isActive,
            "aiot-forceEnable": !!$rename,
            "aiot-togglable": togglable,
            "aiot-expanded": this.state.expanded,
            "aiot-search-selected": searchSelected,
            "aiot-droppable": $droppable && !$_create,
            "aiot-checkable": $checkable,
            "aiot-checked": checked
        });
        // Tree node perhaps deleted?
        if (!$visible) {
            return null;
        }
        // Get icon with multiple checkbox
        const useIcon = selected ? this.props.iconActive || this.props.icon : icon;
        const useIconObj = /*#__PURE__*/ _jsxs("div", {
            className: "aiot-node-icon",
            children: [
                renderIcon ? renderIcon(useIcon, this.props) : useIcon,
                $checkable && /*#__PURE__*/ _jsx(Checkbox, {
                    checked: checked && !indeterminate,
                    indeterminate: indeterminate,
                    onChange: this.handleCheck
                })
            ]
        });
        // Sortable
        const isUlVisible = togglable && isExpanded;
        const isSortable = !!displayChildren /*@TODO && !isTreeLinkDisabled*/  && !$_create;
        const refSortable = (ref)=>displayChildren && ref && onUlRef && onUlRef(ref, id);
        !isUlVisible && displayChildren && onUlRef && onUlRef(undefined, id);
        const createTreeNode = (node, opts)=>/*#__PURE__*/ _jsx(TreeNode, {
                ...node,
                ...nodeAttr,
                ...opts
            }, node.id);
        // Result
        return /*#__PURE__*/ _jsxs("li", {
            className: classNames({
                "aiot-sortable": isSortable
            }),
            "data-li-id": id,
            children: [
                /*#__PURE__*/ _jsx(Spin, {
                    spinning: !!$busy,
                    size: "small",
                    children: /*#__PURE__*/ _jsxs("div", {
                        "data-id": id,
                        tabIndex: 0,
                        className: className,
                        onClick: $_create ? undefined : this.handleSelect,
                        onDoubleClick: $_create || !togglable ? undefined : this.handleToggle,
                        onKeyDown: this.handleNodeKeyDown,
                        ...attr,
                        ref: this.handleRef,
                        children: [
                            useIconObj,
                            $rename ? /*#__PURE__*/ _jsx("input", {
                                autoFocus: true,
                                className: "aiot-node-name",
                                value: this.state.inputValue,
                                onChange: this.handleChange,
                                onKeyDown: this.handleInputKeyDown
                            }) : /*#__PURE__*/ _jsx("div", {
                                className: "aiot-node-name",
                                title: title,
                                children: title
                            }),
                            count > 0 && !$rename && /*#__PURE__*/ _jsx("div", {
                                className: "aiot-node-count",
                                children: count
                            }),
                            $rename && /*#__PURE__*/ _jsx("button", {
                                disabled: !this.state.inputValue,
                                onClick: this.handleButtonSave,
                                children: renameSaveText
                            })
                        ]
                    })
                }),
                isUlVisible && /*#__PURE__*/ _jsxs("ul", {
                    className: classNames({
                        "aiot-sortable-one": childNodes.length === 1
                    }),
                    "data-childs-for": id,
                    ref: refSortable,
                    children: [
                        childNodes.map((node)=>{
                            if (renderItem) {
                                return renderItem(createTreeNode, TreeNode, node);
                            } else {
                                return createTreeNode(node);
                            }
                        }),
                        childNodes.length === 1 && /*#__PURE__*/ _jsx("li", {
                            className: classNames("aiot-sortable-placeholder", {
                                "aiot-sortable": isSortable
                            })
                        }),
                        !!$create && /*#__PURE__*/ _jsx(TreeNode, {
                            $_create: true,
                            renderIcon: renderIcon,
                            onRenameClose: onAddClose,
                            renameSaveText: renameAddText,
                            ...$create
                        })
                    ]
                }),
                !childNodes.length && isSortable && /*#__PURE__*/ _jsx("ul", {
                    "data-childs-for": id,
                    ref: refSortable,
                    className: "aiot-sortable-empty"
                }),
                !!$create && !togglable && /*#__PURE__*/ _jsx("ul", {
                    children: /*#__PURE__*/ _jsx(TreeNode, {
                        $_create: true,
                        renderIcon: renderIcon,
                        onRenameClose: onAddClose,
                        renameSaveText: renameAddText,
                        ...$create
                    })
                }),
                togglable && /*#__PURE__*/ _jsx("div", {
                    onClick: this.handleToggle,
                    className: classNames("aiot-expander", {
                        "aiot-open": isExpanded
                    })
                })
            ]
        });
    }
}
